class LazyVideo extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.video = window.BAO.Utils.getElement('video', { context: this })

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      threshold: 0,
    })
    this.observer.observe(this.video)
  }

  get Play () {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 12">
        <path fill="currentColor" d="m11 6-8 5V1l8 5Z"/>
      </svg>
    `
  }

  get Pause () {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 12">
        <path fill="currentColor" d="M3 1h2v10H3zM7 1h2v10H7z"/>
      </svg>
    `
  }

  addPlayPauseButton () {
    if (this.button) return

    this.button = document.createElement('button')
    this.button.className = 'btn-PlayPause'
    this.button.setAttribute('aria-label', 'Play/Pause decorative video')

    this.appendChild(this.button)

    this.video.addEventListener('play', () => {
      this.button.innerHTML = this.Pause
    })
    this.video.addEventListener('pause', () => {
      this.button.innerHTML = this.Play
    })

    this.button.addEventListener('click', () => this.togglePlayPause())

    this.button.innerHTML = this.video.paused ? this.Play : this.Pause
  }

  togglePlayPause () {
    if (this.video.paused) {
      this.video.play()
    } else {
      this.video.pause()
    }
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches

    if (prefersReducedMotion) {
      this.video.removeAttribute('autoplay')
      this.video.pause()
    }

    if (this.video.dataset?.poster) {
      this.video.setAttribute('poster', this.video.dataset.poster)
    }

    for (const source in this.video.children) {
      const videoSource = this.video.children[source]
      if (
        typeof videoSource.tagName === 'string' &&
        videoSource.tagName === 'SOURCE' &&
        videoSource.dataset?.src
      ) {
        videoSource.src = videoSource.dataset.src
      }
    }

    this.video.load()
    observer.unobserve(this.video)

    this.setAttribute('loaded', '')

    if (this.video.hasAttribute('autoplay')) {
      this.addPlayPauseButton()
    }

    if (
      window.BAO.MediaBreakpoints.isSm ||
      this.video.hasAttribute('autoplay') === false
    ) {
      return
    }

    if (this.video.paused) {
      document.addEventListener('touchstart', () => {
        if (this.video.paused) {
          this.video.play()
        }
      })
    }
  }
}

if (!customElements.get('lazy-video')) {
  customElements.define('lazy-video', LazyVideo)
}
